import { render, staticRenderFns } from "./host-set-projectset.vue?vue&type=template&id=5975385b&scoped=true&"
import script from "./host-set-projectset.vue?vue&type=script&lang=js&"
export * from "./host-set-projectset.vue?vue&type=script&lang=js&"
import style0 from "./host-set-projectset.vue?vue&type=style&index=0&id=5975385b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5975385b",
  null
  
)

export default component.exports